import axios from "axios";
import store from "@/store";
import * as C from "@/common";
import { Api } from "./api";

export interface IUserInfo {
	Nickname: string;
	Species: string;
	ProfilePicture: string | null;
}
export interface IUser extends IUserInfo {
	Mail: string;
	FirstName: string;
	LastName: string;
	Adress_Street: string;
	Adress_Number: string;
	Adress_Zip: string;
	Adress_City: string;
	Adress_Country: string;
	Birthdate: string;
	MobilePhone: string;
}
export interface IUserUpdateData extends Partial<IUser> {
	/** base64-encoded file data-url (including mime-type) */
	NewProfilePictureData?: string;
}
export class AccountApi extends Api {

	private readonly urlAccountPart = "account/";
	public constructor() {
		super();
	}

	protected get BaseUrl() {
		return super.BaseUrl + this.urlAccountPart;
	}

	public async load(id?: number): Promise<IUser> {
		const user = await this.executeWithErrorHandling(() => axios.get<IUser>(this.buildAccountUrl(id), this.Config));

		return user.data;
	}
	public async update(u: Partial<IUserUpdateData>, id?: number): Promise<boolean> {
		const result = await this.executeWithErrorHandling(() => axios.put(this.buildAccountUrl(id), u, this.Config));
		return result.status === 200;
	}

	private buildAccountUrl(id?: number) {
		return this.BaseUrl + (id === undefined ? "" : `${id}/`);
	}
}
